'use client';

import { useMutation } from '@tanstack/react-query';
import { z } from 'zod';

const verificationStatusSchema = z.object({ emailVerified: z.boolean() });

export function useVerificationStatus() {
  return useMutation({
    mutationFn: async () => {
      const response = await fetch('/api/auth/verification-status', { method: 'POST' });
      if (!response.ok) throw new Error('Verification status unavailable');
      return verificationStatusSchema.parse(await response.json());
    },
  });
}
